import React, { useEffect } from "react";
import CalendarComponent from "../controller/Calendar";
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import "../view/css/CalendarPage.css";
import * as firebase from 'firebase';
import Delayed from '../view/Delayed';

export const CalendarPageView = (props) => {

    return (
        <div className="calendarPage">
            <div className="navbar">
                {!props.userLoaded && props.runThis()}
                {props.type_1 === "" ? <NavBarGuest /> : props.type_1 === "Student" ? <NavBarUser /> : <NavBarAffiliate />}
            </div>
            {/* {stop_store_event && */}
            {
                <div className="calendarContent">
                {console.log(props.events)}
                <CalendarComponent noFetchData={props.getEvents} userEvents={props.events} />
                </div>            
            }
        </div>
    );
}